export interface Code {
  code: string;
  campaignName: string;
  campaignDescription: string;
  promotionName: string;
  promotionDescription: string;
  state: CodeState;
}

export enum CodeState {
  ACTIVE = 'ACTIVE',
  PROCESSING = 'PROCESSING',
}
